/**
 * Check if current resolution
 * is below desired
 * @param {Number} resolution
 */
const isBelowBreakpoint = (resolution = 768) => $(window).width() < resolution;

export default isBelowBreakpoint;
